import styled from "@emotion/styled";
const TAG_BACKGROUND_COLOR = "#328048";
export const StyledWhatsNewItemTag = styled.div`
  font-size: 12px;
  border-radius: 4px;
  margin-bottom: 10px;
  display: flex;
  margin-right: 8px;
  background-color: transparent;
  flex-direction: row;
  padding: 6px 12px;

  .icon {
    padding-right: 4px;

    .asset-inner .picture-component img {
      width: 16px;
    }
  }

  .release-status {
    align-self: left;
    background-color: #eafbe7;
    padding: 4px;
    border-radius: 4px;
  }

  .release-status .tag-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 8px;
    align-self: center;
    background-color: ${TAG_BACKGROUND_COLOR};
  }
`;
